import omit from 'lodash/omit';

import { Theme, ThemeSummary } from './theme';
import { apiCall, apiClient } from '../client/apiClient';

export const getAllThemesData = async () => {
  const { data } = await apiClient.GET('/themes/');
  return data as any; //FIXME provide return type;
};

export const getThemeById = async (themeId: string) => {
  const data = await apiCall(apiClient.GET('/themes/{themeId}', { params: { path: { themeId } } }));
  return data as Theme;
};

/**
 * The three write calls go through `apiCall`, which THROWS on a non-2xx. Destructuring `data` off the raw
 * client instead resolved a refusal as `undefined`: `useUpdateTheme` then ran its success path and showed a
 * "saved" notification for a save the server had rejected, and the create/duplicate callbacks destructured
 * `_id` off `undefined` and threw inside React Query's success handler, so neither `onError` ever ran.
 *
 * The return types are ASSERTED rather than inferred. `registerController` declares no response schema for
 * these routes, so the generated client types their 200 body as `unknown` — the assertion is the only place
 * the real shape is stated. Inferring it means declaring the response schemas on the API side and
 * regenerating, which is a contract change rather than a rename.
 */
export const createTheme = async (
  themeDto: Pick<Theme, Exclude<keyof Theme, 'updatedAt' | 'modifiedBy' | '_id'>>
): Promise<ThemeSummary> => {
  return (await apiCall(apiClient.POST('/themes/', { body: themeDto }))) as ThemeSummary;
};

/** Resolves to nothing usable: the controller returns Mongoose's update result, which no caller reads. */
export const updateTheme = async (
  themeDto: Pick<Theme, Exclude<keyof Theme, 'updatedAt' | 'modifiedBy'>>
): Promise<void> => {
  await apiCall(
    apiClient.PATCH('/themes/{themeId}', {
      params: { path: { themeId: themeDto._id } },
      body: omit(themeDto, '_id')
    })
  );
};

export const duplicateTheme = async (id: string, name: string): Promise<ThemeSummary> => {
  return (await apiCall(
    apiClient.POST('/themes/{themeId}/duplicate', {
      params: { path: { themeId: id } },
      body: { name }
    })
  )) as ThemeSummary;
};
